import React,{useState,useEffect } from "react";
import {useDispatch,useSelector} from 'react-redux';
import {getTranslatedMsg} from "../../utils/favoriteMCTranslatedmsg";
import {getDataFromAPI } from "../../service";
import {useIdleTimer} from 'react-idle-timer';
import axios from "axios";
import Cookies from 'js-cookie';
import { AUTH_COOKIE_STORE } from "../constant";

const SessionTimeOut= (props) =>{
		const [showSeesionPopup, setShowSessionPopUp] = useState(false);
		const custlocale=useSelector(state=>state.CommonReducer.locale);
		const msg_signout_data = useSelector(state=> state.CommonReducer.msgSignoutData);
		const dispatch = useDispatch();
		const{REACT_APP_SERVICE_URL,REACT_APP_MC_URL_FLAG} =window.weeksWebCloudConfig;
		const customerId=useSelector(state=>state.CommonReducer.customerId);
		const accessToken=useSelector(state=>state.CommonReducer.accessToken);
    const custlocaleFormated=custlocale.split('_');
	useEffect(() => {
		if(!JSON.parse(localStorage.getItem('loginFormMessage'))){
		getMessage();
		}   
    }, []);

	const getMessage = () =>{
		const NewMsgServiceUrl = `${REACT_APP_SERVICE_URL}/utilities/message-translations/retrieval?messageGroup=loginForm&brandId=1&brand=RCI&locale=${custlocale}&appType=rcio`;
		const OldMsgServiceUrl = `${REACT_APP_SERVICE_URL}/rcio/message/get-message?messageGroup=loginForm&brandId=1&brand=RCI&locale=${custlocale}&ConsumerChannel=Web&MemberType=WEEKS&OperatorId=WEB00USER`;
		REACT_APP_MC_URL_FLAG ?
		getDataFromAPI(NewMsgServiceUrl, "GET", customerId).then(res => {
			if (res.status === 200) {
				if (res.data) {
					dispatch({ type: 'MSG_SIGNOUT_DATA', payload: res.data.data });
					localStorage.setItem('loginFormMessage', JSON.stringify(res.data.data));
				}
			}
		})
		:
		getDataFromAPI(OldMsgServiceUrl, 'GET', customerId, '', accessToken, custlocaleFormated[0], custlocale).then(res => {
					if (res.status === 200) {
						if (res.data) {
							dispatch({type:'MSG_SIGNOUT_DATA',payload:res.data.data});
							localStorage.setItem('loginFormMessage', JSON.stringify(res.data.data));
						}
					}
				})
	   }


	const handleOnAction = (event) => {
		//console.log('user did something', event)
	  }
	
	  /* const handleOnActive = (event) => {
		console.log('user is active', event)
		console.log('time remaining', getRemainingTime())
	  } */
	
	  const handleOnIdle = (event) => {
		//console.log('user is idle', event);
		setShowSessionPopUp(true);
		//console.log('last active', getLastActiveTime())
	  }
	  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
		timeout: 1000 *60 *22 ,
		onIdle: handleOnIdle,
		onAction: handleOnAction,
		debounce: 500
	  })
	const extendSession =() =>{
		axios({url:"/extend-session", method:"GET",params:{ajax:true}});
		setShowSessionPopUp(false);
		
	}
	const timeframe =  1000 *60 *4;
	const remainingTime = getRemainingTime();
	if((remainingTime+1000 *60)>timeframe){
		console.log("signout");
	}
	const sessionSignOut=(e)=>{
        e.stopPropagation();
        sessionStorage.removeItem("NOTIFICATION_FLAG");
		sessionStorage.removeItem("DISMISS_ARPBANNER");
		sessionStorage.removeItem("URL_RESOLVER_TOKEN");
		Cookies.remove(AUTH_COOKIE_STORE);
        window.location.href = "/signout";
		localStorage.removeItem('loginFormMessage');
		setShowSessionPopUp(false);
    }
	
  	return(
		<>
		  {showSeesionPopup && 
		<>	
          <div className="container session-time-out shadow-4 px-5 ">
            <div className="col-12 text-center  pt-4 pb-4"  >
                <h2  data-messagecatalogdetails="MCDE_loginForm_101" className="text-primary mb-5">{getTranslatedMsg(101,JSON.parse(localStorage.getItem('loginFormMessage')),custlocale,'loginForm','Do you Need more time?')}</h2>
                <p className=" p-0 mb-7" data-messagecatalogdetails="MCDE_loginForm_90" >{getTranslatedMsg(90,JSON.parse(localStorage.getItem('loginFormMessage')),custlocale,'loginForm','To protect your account, this session will expire when inactive for more than 30 minutes.')}  </p>
                <div className="col-12 mb-5">
                    <button className="btn btn-outline-secondary w-auto-md w-auto-lg mr-3 mb-3 mb-sm-0" onClick={sessionSignOut} data-messagecatalogdetails="MCDE_loginForm_105" >{getTranslatedMsg(105,JSON.parse(localStorage.getItem('loginFormMessage')),custlocale,'loginForm','SIGN OUT')} </button>
                 <button className=" btn btn-primary w-auto-md w-auto-lg" onClick={extendSession} data-messagecatalogdetails="MCDE_loginForm_104" >{getTranslatedMsg(104,JSON.parse(localStorage.getItem('loginFormMessage')),custlocale,'loginForm','KEEP ME SIGNED IN')}</button>
                </div>
             
            </div>
          </div>
		  <div className="bg-black opacity-25 session-overlay-container position-fixed"></div>
  		</>
  		 
		}
		</>
  		
  	)

  }
export default SessionTimeOut;